<template>
  <div class="doc-card-container">
    <div class="row card-row">
      <div
        v-for="doc in fullDocs"
        :key="doc.id"
        class="doc-card col"
      >
        <h3>
          {{ doc.doc_type }}
        </h3>
        <div class="doc-actionplane">
          <form>
            <div
              v-if="!doc.delivered_at && !doc.available"
              id="file-upload"
              class="form-group"
            >
              <label
                class="custom-file-upload"
                title="Hochladen"
              >
                <i class="fas fa-upload"></i>
                <input
                  :id="'file' + doc.id"
                  class="form-control-file col-sm-12"
                  type="file"
                  @change="handleFileUpload(doc)"
                >
              </label>
              <!-- Up-Modal -->
              <div
                :id="'upmodal' + doc.id"
                class="modal fade modal-position"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5
                        id="exampleModalLabel"
                        class="modal-title"
                      >
                        Dokument hochladen
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <p>Sind Sie sich sicher das es sich um das richtige Dokument handelt?</p>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click="hideModal(doc)"
                      >
                        Nein
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="submitUpload(doc)"
                      >
                        Hochladen
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            <!-- Up-Modal - End -->
            </div>
          </form>
          <button
            v-if="doc.delivered_at"
            class="custom-file-upload"
            type="button"
            title="Löschen"
            @click="handleDeleteFile(doc)"
          >
            <i class="fas fa-trash-alt"></i>
          </button>
          <!-- Delete Modal -->
          <div
            :id="'delMod' + doc.id"
            class="modal fade modal-position"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div
              class="modal-dialog"
              role="document"
            >
              <div class="modal-content">
                <div class="modal-header">
                  <h5
                    id="exampleModalLabel"
                    class="modal-title"
                  >
                    Dokument entfernen
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <p>Sind Sie sicher, dass Sie das Dokument löschen wollen?</p>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    Nein
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="deleteFile(doc)"
                  >
                    Löschen
                  </button>
                </div>
              </div>
            </div>
          </div>
        <!-- Delete Modal End -->
        </div>
        <!-- v-on:dragleave.prevent="dragLeave($event)" -->
        <div
          v-if="!doc.delivered_at && !doc.available"
          class="border-box"
          draggable="true"
          dropzone="true"
          @dragover.prevent="dragHandler($event)"
          @drop.prevent="dropHandler($event, doc)"
        >
          <i class="fas fa-unlock box-lock fa-4x"></i>
        </div>
        <div
          v-if="doc.delivered_at || doc.available"
          class="border-box"
        >
          <i class="fas fa-lock box-lock fa-4x"></i>
        </div>
        <div class="doc-status">
          <div class="status-delivered">
            <span class="status-desc">geliefert am:</span>
            <span
              v-if="doc.delivered_at !== null"
              class="status-value"
            >{{ doc.delivered_at }}</span>
            <span
              v-if="doc.delivered_at === null"
              class="status-value"
            > wurde noch nicht zugestellt</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    documents: {
			type: Array,
			required: true
		}
  },
  data () {
    return {
      docTypes: [],
      fullDocs: [],
      file: ''
    }
  },
  mounted () {
    this.$axios.get(process.env.VUE_APP_BASE_URI + 'doctypes')
      .then((response) => {
        this.docTypes = response.data
        this.documents.forEach(doc => {
          this.docTypes.forEach(type => {
            if (doc.type_id === type.id) {
              doc.doc_type = type.doc_type
              doc.code = type.code
            }
          })
        })
        this.fullDocs = this.documents
      })
  },
  methods: {
    dragLeave () {
      //
    },
    dragHandler () {
      //
    },
    dropHandler (evt, doc) {
      var mod = 'upmodal' + doc.id
      this.file = evt.dataTransfer.files[0]
      let element = document.getElementById(mod)
      $(element).modal('show')
    },
    handleFileUpload (doc) {
      var exid = 'file' + doc.id
      var mod = 'upmodal' + doc.id
      this.file = document.getElementById(exid).files[0]
      let element = document.getElementById(mod)
      $(element).modal('show')
    },
    handleDeleteFile (doc) {
      var del = 'delMod' + doc.id
      let element = document.getElementById(del)
      $(element).modal('show')
    },
    submitUpload (doc) {
      var mod = 'upmodal' + doc.id

      let formData = new FormData()
      formData.append('file', this.file)
      formData.append('doc_id', doc.id)
      formData.append('code', doc.code)
      this.$axios.post(process.env.VUE_APP_BASE_URI + 'sadmin/docUpload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(() => {
          let element = document.getElementById(mod)
          $(element).modal('hide')
          this.$router.go()
        })
    },
    deleteFile (doc) {
      this.$axios.delete(process.env.VUE_APP_BASE_URI + 'sadmin/doc/' + doc.id)
        .then(() => {
          var el = 'delMod' + doc.id
          let element = document.getElementById(el)
          $(element).modal('hide')
          this.$router.go()
        })
    },
    hideModal (doc) {
      var mod = 'upmodal' + doc.id
      var file = 'file' + doc.id
      this.file = ''
      let element = document.getElementById(mod)
      $(element).modal('hide')
      document.getElementById(file).value = null
    }
  }
}
</script>
<style scoped>
	.modal-content {
		height: unset !important;
	}
	.delModal {
		height: 284px !important;
	}
	.modal-body {
		height: unset !important;
	}
</style>

